<div class="row">
	<div id="page-wrapper">
		<div id="content-header">
			<div id="dvCompanyFullName" class="customer-name-container">
				<span>
					<a 
						*ngIf="hasCustomerSitesReportsPage; else notACTuser" 
						[routerLink]="[ '/', customer.id ,'customer-sites-reports', 'default']">{{customer.name}}</a>
					<ng-template #notACTuser>{{customer.name}}</ng-template>
				</span>
			</div>
			<div *ngIf="user.isACTuser" class="equipment-container">
				<a [routerLink]="['/equipments-devices', 'customer', customer.id]">View Equipments</a>
			</div>
		</div>
		<div *ngIf="showToggleIntelligentFilter">
			<div class="checkbox-container">
				<input
					[checked]="intelligentSitesCheckbox"
					(change)="toggleIntelligentFilter()"
					type="checkbox"
					name="intelligent"
					id="intelligent" />
				<label for="intelligent" class="label-act-intel">ACT Intelligent Enabled Sites Only</label>
			</div>
		</div>
		<div class="margin-top-lg"></div>
		<div id="tab-content" class="row">
			<app-widgets-loader key="company" [data]="data" [passAllDataOnce]="true"></app-widgets-loader>
		</div>
	</div>
</div>
